import { Grid } from '@mui/material';
import { CfDataGridForStoreDataProps } from '../../../CfDataGridProps';
import { getColumnCount } from '../../../utility/data-grid-props';
import { CfDataGridCardByItemId } from '../card/CfDataGridCardByItemId';
import { CfDataGridCardRowBaseProps } from './common';

export function CfDataGridCardRowByItemId<TItem, TAppState>(props: {
  baseProps: CfDataGridCardRowBaseProps<TItem>;
  itemIds: { itemId: string | undefined; isLoading: boolean; after?: boolean }[];
  dataGridProps: CfDataGridForStoreDataProps<TItem, TAppState>;
}): JSX.Element {
  const { baseProps, itemIds, dataGridProps } = props;
  const columnCount = getColumnCount(baseProps.cardViewDefinition, baseProps.orientation);

  const indexOffset = baseProps.rowIndex * columnCount;
  return (
    <Grid container columnSpacing={2} sx={{ paddingTop: 2 }}>
      {itemIds.map((x, index: number) => (
        <CfDataGridCardByItemId<TItem, TAppState>
          key={(x.itemId ?? '') + index}
          itemId={x.itemId}
          after={x.after}
          cardViewDefinition={baseProps.cardViewDefinition}
          index={indexOffset + index}
          itemSelector={dataGridProps.storeData.itemSelector}
          useSelector={dataGridProps.storeData.useSelector}
          onItemClicked={dataGridProps.onItemClicked}
          hoverStyle={dataGridProps.hoverStyle}
          cursorStyle={dataGridProps.cursorStyle}
          setNavigableElement={baseProps.setNavigableElement}
          recomputeRowHeights={baseProps.recomputeRowHeights}
          recomputeRowHeight={baseProps.recomputeRowHeight}
          orientation={baseProps.orientation}
        />
      ))}
    </Grid>
  );
}
